import { Card } from 'components/Card/styles';
import { lighten, transparentize, darken } from 'polished';
import styled, { css } from 'styled-components';
import { device } from 'styles/device';

export const Container = styled.div`
  /* display: flex;
  flex-direction: column;
  height: 100%; */
  /* height: 100vh; */
  height: -webkit-fill-available;
`;

export const Header = styled.header`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h2 {
    color: ${props => props.theme.fontColor};
    font-weight: 300;
  }
  span {
    color: ${props => props.theme.fontColor};
  }
`;

export const Content = styled.div`
  display: flex;
  /* height: 100%; */
  min-height: calc(100vh - 190px);
`;

export const GeneralData = styled.div`
  padding: 15px;
  flex: 1;

  > div {
    display: flex;
  }

  @media ${device.laptopL} {
    min-width: 500px;
  }
`;

export const GeneralDataHeader = styled.div`
  display: flex;
  align-items: baseline;
  border-bottom: 1px solid ${props => props.theme.componentborder};
  width: 100%;
  h3 {
    width: 100%;
    font-size: 24px;
    color: ${props => props.theme.fontColor};
  }
`;

export const TimelineData = styled(Card)`
  padding: 15px;
  flex: 0.5;
  min-width: 450px;

  height: calc(100vh - 180px);
  @media ${device.desktop} {
    min-width: 550px;
    height: 100vh;
  }
`;

export const Info = styled.ul`
  text-decoration: none;
  width: 100%;
  margin-top: 15px;

  li {
    display: flex;
    align-items: center;
    margin-top: 5px;

    p {
      font-size: 16px;
      color: ${props => props.theme.fontColor};
    }
    strong {
      margin-left: 10px;
      font-size: 16px;
      color: ${props => props.theme.fontColor};
    }

    > div {
      margin-left: 10px;
      font-size: 14px;
    }
  }
`;

interface IAvaliacao {
  status: 'pendente' | 'aprovado' | 'ressalva' | 'reprovado';
}
export const Avaliacao = styled.section<IAvaliacao>`
  display: flex;
  flex-direction: column;
  /* cursor: pointer; */
  margin-top: 20px;
  align-items: flex-start;
  flex: 1;
  width: 100%;
/*
  opacity: ${props =>
    ['unapproved', 'failed'].includes(props.status) ? '0.6' : '1'}; */

  & + div {
    margin-top: 16px;
  }
  /* mobile */
  @media ${device.laptopM} {
    &:last-of-type {
      margin-bottom: 200px;
    }
  }

  > div {
    &:nth-child(2){
      margin-top: 15px;
      background:  ${props => props.theme.cardBackgroud};
      display: flex;
      flex: 1;
      align-items: center;
      padding: 16px 24px;
      border-radius: 10px;

      position: relative;


      // dekstop
      @media ${device.desktopL} {
        width: 100%;
      }

      border: ${props =>
        props.theme.name === 'dark'
          ? 'none'
          : `2px solid ${props.theme.cardBorder}`};


      box-shadow: ${props =>
        props.theme.name === 'dark'
          ? ' 0 1px 20px 0 rgba(0, 0, 0, 0.1)'
          : '0 1px 15px 0 hsla(0, 0%, 48.2%, 0.05)'};




      &::before {
        content: "";
        position: absolute;
        border-radius: 0 5px 5px 0;
        height: 80%;
        width: 4px;
        left: 0;
        top: 10%;


        background: ${props => props.theme.flag[props.status]};
      }

      transition: transform 0.2s;

      &:hover {
        transform: translateX(10px);
      }

      section {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: center;
      }
    }
  }
`;

interface InfoAvaliacao {
  status: 'pendente' | 'aprovado' | 'ressalva' | 'reprovado';
}
export const InfoAvaliacao = styled.div<InfoAvaliacao>`
  flex: 1;
  margin-left: 15px;

  div {
    display: flex;
    align-items: baseline;

    h4 {
      font-weight: 400;
      line-height: 21px;
      font-size: clamp(1rem, 2.5vw, 1.3rem);
      text-transform: capitalize;
      color: ${props => props.theme.flag[props.status]};
    }
    > span {
      margin-left: 10px;
      font-style: italic;
      color: #999591;
      opacity: 0.8;
      font-size: 14px;
    }
  }

  p {
    width: 100%;
    margin-top: 10px;
    font-weight: 400;
    font-size: clamp(0.6rem, 2vw, 1rem);
    text-transform: initial;
    color: ${props => props.theme.fontColor};
  }

  strong {
    font-size: clamp(0.7rem, 2.5vw, 1rem);
    line-height: 18px;
    color: #999591;
  }
`;

export const Engenharia = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  // dekstop
  @media ${device.desktop} {
    flex-direction: column;
  }

  section {
    margin-right: 15px;
  }
`;

export const MidiaInfo = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: flex-start;
  flex: 0.7;

  // dekstop
  @media ${device.desktopL} {
    width: 100%;
  }

  ul {
    text-decoration: none;
    width: 100%;
    margin-top: 15px;

    li {
      display: flex;
      align-items: center;
      margin-top: 5px;
      width: 100%;
      justify-content: space-between;
      align-items: flex-start;
      p {
        font-size: 16px;
        color: ${props => props.theme.fontColor};
      }
      strong {
        margin-left: 10px;
        font-size: 16px;
        color: ${props => props.theme.fontColor};
      }
      > div {
        margin-left: 10px;
        display: flex;
        flex-direction: column;

        div,
        strong {
          margin-bottom: 5px !important;
        }
      }
    }
  }
`;

export const EnviaExibidor = styled.section`
  table {
    width: 100%;
    border-collapse: collapse;
    thead {
      tr {
        th {
          text-align: left;
          padding: 10px 0px;
          color: ${props => props.theme.fontColor};
          font-size: 1.0625rem;
          font-weight: 400 !important;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 0.1px solid
          ${props => transparentize(0.7, props.theme.fontColor)};
        &:last-of-type {
          border-bottom: none;
        }
        td {
          padding: 10px 0px;

          font-size: 1.0625rem;
          color: ${props => props.theme.fontColor};

          button {
            margin: 0;
          }
        }

        &:hover {
          transition: all 0.25s ease;
          ${props =>
            props.theme.name === 'dark'
              ? css`
                  background-color: ${props =>
                    lighten(0.03, props.theme.cardBackgroud)};
                `
              : css`
                  background-color: ${props =>
                    darken(0.03, props.theme.cardBackgroud)};
                `}
        }
      }
    }
  }
`;

export const Table = styled.table`
  th {
    &:nth-of-type(2) {
      width: 10rem;
      text-align: center;
    }
    &:nth-of-type(3) {
      width: 7rem;
    }
    &:last-of-type {
      width: 10rem;
    }
  }
  td {
    padding: 10px 10px 10px 0px !important;
    font-size: 1.0625rem;
    color: ${props => props.theme.fontColor};
    p {
      text-align: center;
    }
    button {
      margin: 0;
    }
    &:first-of-type {
      display: flex;
      > h4 {
        margin-right: 1rem;
      }
      div {
        padding-right: 8px;
        align-self: center;
        h4 {
          font-size: 14px;
          opacity: 0.7;
          font-style: italic;
        }
      }
    }
    &:nth-of-type(3) {
      > div {
        display: flex !important;
        margin: 0 auto;
      }
    }
  }
`;
